import { useEffect } from "react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/useTypedSelector";
import { getPlanningRoutes } from "../redux/thunks/route/getPlanningRoutesThunk";

export const usePlanningUpdateCheckerHook = () => {
  const { events } = useAppSelector((state) => state.eventMutate);
  const dispatch = useAppDispatch();

  useEffect(() => {
    events.forEach((event) => {
      if (
        event.type === "REQUEST_ADD_TO_EXISTING_ROUTE" ||
        event.type === "ROUTE_GENERATED"
      ) {
        void dispatch(getPlanningRoutes());
      }
    });
  }, [events]);

  useEffect(() => {
    const interval = setInterval(() => {
      void dispatch(getPlanningRoutes());
    }, 15000);

    return () => clearInterval(interval);
  }, [dispatch]);
};
